import DOMPurify from "dompurify";

/**
 * Sanitizes an HTML string so it can be safely rendered via dangerouslySetInnerHTML.
 * Returns an empty string for null/undefined input.
 */
export const sanitizeHtml = (html?: string | null): string => {
  if (!html) return "";
  return DOMPurify.sanitize(html);
};
